import { pawnshop_reports_settings_service } from "../../../api/restclient";

export const getBranchTargetsCollection = () => {
  try {
    const params = {};
    return pawnshop_reports_settings_service.get(
      "/settings/branchTargets",
      params
    );
  } catch {
    return Promise.resolve();
  }
};

export const getSingleBranchTargets = (data) => {
  try {
    const params = {};
    return pawnshop_reports_settings_service.get(
      `/settings/branchTargets${data.id}`,
      params
    );
  } catch {
    return Promise.resolve();
  }
};

export const addBranchTargets = (data) => {
  try {
    var urlParams = new URLSearchParams();
    urlParams.append("branchCode", data.branchCode);
    urlParams.append("month", data.month);
    urlParams.append("year", data.year);
    urlParams.append("targetPiece", data.targetPiece);
    urlParams.append("targetPrincipal", data.targetPrincipal);
    return pawnshop_reports_settings_service.post(
      `/settings/branchTargets?${urlParams}`
    );
  } catch {
    return Promise.resolve();
  }
};

export const deleteBranchTargets = (data) => {
  try {
    const params = {};
    return pawnshop_reports_settings_service.delete(
      `/settings/branchTargets/${data.id}`,
      params
    );
  } catch {
    return Promise.resolve();
  }
};

export const updateBranchTargets = (data) => {
  try {
    var urlParams = new URLSearchParams();
    urlParams.append("branchCode", data.branchCode);
    urlParams.append("month", data.month);
    urlParams.append("year", data.year);
    urlParams.append("targetPieces", data.targetPiece);
    urlParams.append("targetPrincipal", data.targetPrincipal);
    return pawnshop_reports_settings_service.put(
      `/settings/branchTargets/${data.id}?${urlParams.toString()}`
    );
  } catch {
    return Promise.resolve();
  }
};

export const UploadBatchBranchData = (data) => {
  try {
    var formData = new FormData();
    formData.append("file", data.file[0]);
    return pawnshop_reports_settings_service.post(
      `/settings/batch-branchTargets`,
      formData,
      {
        headers: {
          "content-type": "multipart/form-data;",
          accept: "*/*",
        },
      }
    );
  } catch {
    return Promise.resolve();
  }
};
